module.exports = __webpack_public_path__ + "static/media/gallarang.e4c9877f.png";